import { Doc, Id } from "../../_generated/dataModel";
import { FilterRule } from "../../lib/types/filters_types";

export const permissionsRoleRule: FilterRule<Doc<"permissions">> = {
  priority: 3,
  // Sin roleId devuelve [] (no "sin filtro"): no usar paginación por índice.
  appliesWithoutArgs: true,
  build: async (ctx, args) => {
    const { userContext } = ctx;
    if (!args.roleId) return [];

    if (userContext?.companyId) {
      const permissions = await ctx.db
        .query("permissions")
        .withIndex("by_company_id_role_id", (q) =>
          q
            .eq("internalControl.companyId", userContext.companyId!)
            .eq("roleId", args.roleId),
        )
        .collect();

      return permissions;
    }
  },
};
